import { config } from '@/pageConfig/claims/nl/nl';
import { ClaimsPageTemplate } from '@/pageTemplate/ClaimsPageTemplate';

export default function ClaimsPage() {
  return <ClaimsPageTemplate config={config} />;
}
